import { PaymentRequestWorkerStatus } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

export const getWorkerStatusLabel = (status: PaymentRequestWorkerStatus): string => {
  switch (status) {
    case PaymentRequestWorkerStatus.Approved:
      return $t('Approved')
    case PaymentRequestWorkerStatus.Cancelled:
      return $t('Cancelled')
    case PaymentRequestWorkerStatus.Completed:
      return $t('Completed')
    case PaymentRequestWorkerStatus.Draft:
      return $t('Draft')
    case PaymentRequestWorkerStatus.Processing:
      return $t('Processing')
    case PaymentRequestWorkerStatus.Requested:
      return $t('Requested')
    case PaymentRequestWorkerStatus.Rejected:
      return $t('Rejected')
    default:
      return $t('Requested')
  }
}
